import React, { useContext } from "react";
import slugify from "slugify";
import { Link } from "react-router-dom";
import GifPlayer from "../common/GifPlayer";
import { siteUrl } from "../../utils/constants";
import { DataContext } from "../../context/DataContext";
import type { DocumentEntity, VideoEntity } from "../../types/strapi";
import { getImageUrl } from "../../utils/archiveElementUtils";
import { mediaUrl } from "../../utils/imageUtils";

interface ArchiveElementProps {
  column?: string;
  item: DocumentEntity | VideoEntity;
  type: string;
}

const ArchiveElement: React.FC<ArchiveElementProps> = ({
  column,
  item,
  type,
}) => {
  const { setCollectionNameAndItemId } = useContext(DataContext);

  const handleClick = () => {
    setCollectionNameAndItemId(type, item.documentId);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      setCollectionNameAndItemId(type, item.documentId);
    }
  };

  const isDocumentEntity = (
    item: DocumentEntity | VideoEntity
  ): item is DocumentEntity => {
    return "file" in item;
  };

  const firstFile = isDocumentEntity(item)
    ? item.file?.[0]
    : undefined;
  const isGif = firstFile?.ext === ".gif";
  const fileUrl = firstFile?.url;
  const imageUrl = getImageUrl(item as Parameters<typeof getImageUrl>[0]);

  return (
    <div className={column}>
      <div className="item-portfolio-static">
        <div>
          <div className="portfolio-static">
            <div className="thumbnail-inner">
              <div className="thumbnail">
                <Link
                  to={`/archive/${
                    item?.contentType
                      ? slugify(item.contentType.title, {
                          lower: true,
                          strict: true,
                          trim: true,
                        })
                      : ""
                  }`}
                  onClick={handleClick}
                  onKeyDown={handleKeyDown}
                >
                  {imageUrl && !isGif && (
                    <img src={mediaUrl(imageUrl)} alt="Portfolio Images" />
                  )}

                  {isGif && fileUrl && (
                    <GifPlayer
                      gif={mediaUrl(fileUrl)}
                      autoplay
                      className="image-gif-centered"
                    />
                  )}
                </Link>
              </div>
            </div>
            <div className="content">
              <div className="inner">
                <p>
                  {item?.contentType?.dublin_core_type
                    ? item?.contentType?.dublin_core_type?.name
                    : ""}
                </p>
                <h4>
                  <Link
                    to={`/archive/${
                      item?.contentType
                        ? slugify(item.contentType.title, {
                            lower: true,
                            strict: true,
                            trim: true,
                          })
                        : ""
                    }`}
                    onClick={handleClick}
                    onKeyDown={handleKeyDown}
                  >
                    {item?.contentType?.title || ""}
                  </Link>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArchiveElement;
